{
  "version": 1,
  "asset_id": "0e906d71-d32e-4e1a-ae6a-140e3e1500f0",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/0e906d71-d32e-4e1a-ae6a-140e3e1500f0/clip-img_2031.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/0e906d71-d32e-4e1a-ae6a-140e3e1500f0/clip-img_2031.mp4",
  "original_filename": "clip-img_2031.mp4",
  "size": 320083,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:39Z"
}
